__turbopack_context__.v({
  "description__contents": "ContentsDescription-module-scss-module__-g_7AW__description__contents",
  "description__contents__img": "ContentsDescription-module-scss-module__-g_7AW__description__contents__img",
  "description__contents__textarea--bottom--long": "ContentsDescription-module-scss-module__-g_7AW__description__contents__textarea--bottom--long",
  "description__contents__textarea--bottom--short": "ContentsDescription-module-scss-module__-g_7AW__description__contents__textarea--bottom--short",
  "description__contents__textarea--top": "ContentsDescription-module-scss-module__-g_7AW__description__contents__textarea--top",
});
